// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PageFixMisspellingUtil } from './PageFixMisspelling.util';
import { PageFixRepoService } from '@client/app/services/api/pagefix-repo/page-fix-repo.service';
import { PAGE_FIX_FIXABLE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-fixable-types';
import { PAGE_FIX_SELECTOR_QUERIES } from '@client/app/modules/page-fix/constants/page-fix-selector-queries';
import { PAGE_FIX_CHANGE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-change-types';

@Component({
    selector: 'page-fix-form-misspelling',
    templateUrl: './page-fix-form-misspelling.component.html',
    standalone: false,
})
export class PageFixFormMisspellingComponent implements OnInit {
    @Input() resolve: any;
    @Output() close = new EventEmitter<any>();
    @Output() dismiss = new EventEmitter<void>();

    misspelling: string | string[] = '';
    correctSpelling = '';
    pageFix: any;

    constructor (private pageFixRepoService: PageFixRepoService) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        const pageFixMisspellingUtil = new PageFixMisspellingUtil();
        pageFixMisspellingUtil.setModel(this.resolve.model);
        pageFixMisspellingUtil.setPageFix(this.resolve.pageFix);
        pageFixMisspellingUtil.setupSettings();
        this.misspelling = pageFixMisspellingUtil.getMisspelling();
        this.correctSpelling = pageFixMisspellingUtil.getCorrectSpelling();
        this.pageFix = pageFixMisspellingUtil.getPageFix();
    }

    submit (): void {
        let promise;
        const change = {
            value: this.correctSpelling,
        };

        if (this.pageFix) {
            promise = this.pageFixRepoService.update(this.pageFix, {
                change: change,
            }, {});
        } else {
            promise = this.pageFixRepoService.create({
                change: change,
                selector: PAGE_FIX_SELECTOR_QUERIES.tree_walker + ';' + this.misspelling,
                fixable_type: PAGE_FIX_FIXABLE_TYPES.misspelling,
                fixable_id: this.resolve.typeId || this.resolve.model.id,
                change_type: PAGE_FIX_CHANGE_TYPES.word,
            }, undefined);
        }

        promise.then((pageFix: any) => {
            this.closeModal(pageFix);
        });
    }

    cancel (): void {
        this.dismiss.emit();
    }

    closeModal (result: any): void {
        this.close.emit({ $value: result });
    }
}
